<template>
	<div class="row">
		<div class="mr-auto ml-auto  col-lg-10">
			<button @click="addNewProfile" class="btn btn-primary">
				<i class="fa fa-plus" aria-hidden="true" />
				{{ 'Create' | translate }} {{ 'Teacher' | translate }}
			</button>
			<!-- <button class="btn btn-secondary">
        <i class="fa fa-file-excel-o" aria-hidden="true"/>
        {{ 'Download' | translate }}
      </button>
      <button
        :disabled='checkedProfile.length === 0'
        class="btn btn-secondary"
        @click.prevent='openModal(checkedProfile, "email")'>
        {{ 'Send email' | translate }}
      </button>       -->
			<div class="table-responsive">
				<table class="table">
					<tr>
						<!-- <th>
							<input
								@change="checkAll"
								v-model="checkAllInput"
								type="checkbox"
							/>
						</th> -->
						<th>ID</th>
						<th>{{ 'Payment Amount' | translate }}</th>
						<th>{{ 'Person' | translate }}</th>
						<th>{{ 'Region' | translate }}</th>
						<th>{{ 'Statistics' | translate }}</th>
						<th>{{ 'Actions' | translate }}</th>
					</tr>
					<tr v-for="profile in listProfiles" :key="profile.id">
						<!-- <td>
							<input
								v-model="checkedProfile"
								:value="profile.id"
								type="checkbox"
								ref="input"
							/>
						</td> -->
						<td>{{ profile.id }}</td>
						<td>
							{{ profile.invoice.amount ? profile.invoice.amount : '0' }}
							{{ profile.currency | toSymbol }}
						</td>
						<td>
							<router-link :to="{ name: 'Dashboard Profile', params: { id: profile.id } }">
								{{ profile.last_name }} {{ profile.first_name }}
							</router-link>
						</td>
						<td>{{ profile.region }}</td>
						<td>
							<div>
								<span>{{ 'Students' | translate }}:</span>
								<router-link v-b-tooltip.hover :title="$t(`total`)" class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'student' },
			}">{{ profile.statistic.students_total }}</router-link>
								/
								<router-link v-b-tooltip.hover :title="$t(`active`)" class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'student' },
			}">{{ profile.statistic.students_active }}</router-link>
								/
								<router-link v-b-tooltip.hover :title="$t(`blocked`)" class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'student' },
			}">{{ profile.statistic.students_inactive }}</router-link>
							</div>
							<div>
								<span>{{ 'Groups' | translate }}:</span>
								<router-link class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'group' },
			}">{{ profile.statistic.groups_total }}</router-link>
							</div>
							<div>
								<span>{{ 'Parents' | translate }}:</span>
								<router-link class="dib" :to="{
				name: 'Dashboard List',
				query: { parent: profile.id },
				params: { role: 'parent' },
			}">{{ profile.statistic.parents_total }}</router-link>
							</div>
						</td>
						<td>
							<a href="#" @click.prevent="openModal(profile.id, 'delete')" class="text-red outline outline-red">{{
				'Block' | translate }}</a>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { toSymbol } from '@/helpers/filters'
export default {
	name: 'Teacher',
	data() {
		return {
			checkedProfile: [],
			checkAllInput: false,
		}
	},
	computed: {
		listProfiles() {
			return this.$store.state.profiles
		},
	},
	filters: {
		toSymbol,
	},
	methods: {
		addNewProfile() {
			this.$router.push({
				name: 'Dashboard Add',
				params: { role: this.$route.params.role },
			})
		},
		checkAll() {
			this.checkedProfile = []
			if (this.checkAllInput) {
				this.checkedProfile = this.listProfiles.map(profile =>
					Number(profile.id)
				)
			}
		},
		openModal(id, type) {
			if (typeof id === 'number') {
				let profileArr = []
				profileArr.push(id)
				this.$store.commit('changeModalId', profileArr)
			} else {
				this.$store.commit('changeModalId', id)
			}
			this.$store.commit('changeModalType', type)
			this.$emit('openModal')
		},
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (max-width: 576px) {
	.offset-lg-1>.btn {
		width: 100%;
		margin-bottom: 10px;
	}
}
</style>
